import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/authSlice'; // sesuaikan path

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

export default store;
